import React, { useState } from 'react'
import MaterialTable from 'material-table'
// import Edit from '@material-ui/icons/Edit'
// import Close from '@material-ui/icons/Close'
import LockOpen from '@material-ui/icons/LockOpenRounded'


import { minPermisos } from 'src/constants/permits'
import { tableIcons, useStyles } from '../styles'

const UsersBlockedTable = (props) => {
  const {
    idPermisoTabla,
    handleOnChange,
    // handleDelete,
    handleUnlock,
    // handleEdit,
    dataTable = [],
    status,
    columns,
    loading,
  } = props
  const classes = useStyles()
  const [selected, setSelectedRow] = useState(null)

  return (
    <div className={classes.root}>
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} of {count}',
            },
            toolbar: {
              nRowsSelected: '{0} row(s) selected',
            },
            header: {
              actions: 'Acción',
            },
            body: {
              // emptyDataSourceMessage: dataTable && <CircularProgress />,
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
          // icons={tableIcons}
          title="🔒 Usuarios Bloqueados"
          columns={columns}
          data={dataTable}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow.tableData.id)
          }
          options={{
            loadingType: 'linear',
            selection: status,
            pageSize: 10,
            actionsColumnIndex: -1,
            draggable: false,
            filtering: false,
            search: true,
            toolbar: true,
            padding: 'dense',
            loading,
            exportButton: true,
            exportAllData: true,
            showTextRowsSelected: false,
            showSelectAllCheckbox: false,
            exportFileName: 'Exportación Lucia Analitics',
            headerStyle: {
              backgroundColor: '#1B1B1B',
              color: '#FFF',
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                selected === rowData.tableData.id ? '#EEE' : '#FFF',
              wordWrap: 'break-word',
              fontSize: 14,
            }),
            selectionProps: (rowData) => ({
              // disabled: rowData.id !== rowData.id,
              color: rowData?.tableData?.estado == 1 ? 'primary' : 'secondary',
            }),
          }}
          onSelectionChange={(rowData, selectedRow) =>
            handleOnChange(selectedRow)
          }
          actions={[
            {
              icon: () => (
                <LockOpen
                  className={classes.tableActionButtonIcon}
                  style={{ color: '#4CAF50' }}
                />
              ),
              tooltip: 'Desbloquear',
              onClick: (event, rowData) => handleUnlock({ event, rowData }),
              hidden:
                status || !(idPermisoTabla >= minPermisos.ACTUALIZAR || null),
            },
            // {
            //   icon: () => (
            //     <Edit
            //       className={classes.tableActionButtonIcon}
            //       style={{ color: '#4CAF50' }}
            //     />
            //   ),
            //   tooltip: 'Editar',
            //   onClick: (event, rowData) => handleEdit({ event, rowData }),
            //   hidden:
            //     status || !(idPermisoTabla >= minPermisos.ACTUALIZAR || null),
            // },
            // {
            //   icon: () => (
            //     <Close
            //       className={classes.tableActionButtonIcon}
            //       style={{ color: '#f44336 ' }}
            //     />
            //   ),
            //   tooltip: 'Eliminar',
            //   onClick: (event, rowData) => handleUnlock({ event, rowData }),
            //   hidden:
            //     status || !(idPermisoTabla >= minPermisos.ELIMINAR || null),
            // },
          ]}
        />
      </div>
    </div>
  )
}

export default UsersBlockedTable
